import { render, staticRenderFns } from "./NodeText.vue?vue&type=template&id=1b3dcea6"
import script from "./NodeText.vue?vue&type=script&lang=js"
export * from "./NodeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports